var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Dropdown, ListItem, FormController, FormLabel, } from '@one-thd/sui-atomic-components';
export var formatCityState = function (city, state) {
    return "".concat(city, ", ").concat(state);
};
export var CityStateSelect = React.forwardRef(function (props, ref) {
    var cities = props.cities;
    return (React.createElement(FormController, { fullWidth: true },
        React.createElement(FormLabel, null, "City, State*"),
        React.createElement(Dropdown, __assign({ label: props.value, ref: ref, placeholder: "" }, props), (cities === null || cities === void 0 ? void 0 : cities.length) &&
            cities.map(function (_a) {
                var city = _a.city, state = _a.state;
                return (React.createElement(ListItem, { key: city, value: formatCityState(city, state) }, formatCityState(city, state)));
            }))));
});
